/*
 * Functional programming curry helper ( f(x) -> g(x) = f(g(x)) )
 */
const curry = (fn) => {
  const arity = fn.length;
  return (function resolver(...args) {
    const memory = args.slice();
    return (...nextArgs) => {
      const local = memory.slice();
      local.push(...nextArgs);
      const next = local.length >= arity ? fn : resolver;
      return next(...local);
    };
  }());
};

export default curry;



// WEBPACK FOOTER //
// ./app/utils/functionalHelpers/curry.js